import { Link } from 'react-router-dom';
import { videos, VideoItem } from '@/mocks/videos';

function VideoCard({ video }: { video: VideoItem }) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-300 overflow-hidden transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/70 text-background-50 text-xs">
          {video.duration}
        </div>
        {video.isPremium && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            精品
          </div>
        )}
      </div>

      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {video.title}
        </h3>
        <p className="text-foreground-500 text-xs mt-2 line-clamp-2 leading-relaxed">
          {video.description}
        </p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-100">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500"></i>
              {video.rating}
            </span>
          </div>
          <span className="text-xs px-2 py-1 rounded-md bg-secondary-100 text-secondary-700 font-medium">
            {video.categoryName}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function VideoGrid() {
  const featuredVideos = videos.filter((v) => v.isFeatured).slice(0, 4);
  const latestVideos = videos.slice(0, 8);

  return (
    <section className="w-full bg-background-100/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">
              编辑精选的高品质内容，不容错过
            </p>
          </div>
          <Link
            to="/category/jiaoyu"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="mt-12 md:mt-14">
          <div className="flex items-end justify-between mb-8 md:mb-10">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
                最新上线
              </h2>
              <p className="text-foreground-500 text-sm">
                持续更新的优质视频内容
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {latestVideos.map((video) => (
              <VideoCard key={`latest-${video.id}`} video={video} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}